import React from "react";
import ProjectOverviewV2 from "../ProjectOverviewV2/ProjectOverviewV2";

function EditProject({
  account_id,
  account_slug,
  statusLabels,
  salesExecutiveCreatePermission,
  projectOverviewPrivilege,
  requestApprovalPrivilege,
  blueprintCreatePermission,
}) {
  const location = window.location.href;
  var locationArr = location.split("/");
  var id = locationArr[locationArr.length - 2];

  return (
    <ProjectOverviewV2
      projectId={id}
      statusLabels={statusLabels}
      salesExecutiveCreatePermission={salesExecutiveCreatePermission}
      projectOverviewPrivilege={projectOverviewPrivilege}
      requestApprovalPrivilege={requestApprovalPrivilege}
      blueprintCreatePermission={blueprintCreatePermission}
    />
  );
}

export default EditProject;
